import { Autoplay, FreeMode, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import useIsMobile from '../../../hook/useIsMobile';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import FadeInUp from '../../../components/FadeInUp';

export default function Contact() {

  const LEN = 10;
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <section>
      <div className='flex flex-col items-center top-space'>
        <FadeInUp>
          <h2 className='text-center font-bold text-title2 lg:text-display2'>
            기술과 수치로 증명하는 링콜의 신뢰<br />
            누구나 믿고 사용할 수 있는 안전 기술을 만듭니다.
          </h2>
        </FadeInUp>

        <FadeInUp delay={0.3}>
          <button
            onClick={() => navigate('/contact')}
            className='mt-[60px] py-[20px] px-[50px] font-bold bg-primary-400 text-white text-heading2 lg:text-title3'>
            구매 문의
          </button>
        </FadeInUp>
      </div>

      <div className='flex flex-wrap items-center justify-center gap-[15px] lg:gap-[30px] mt-[80px] lg:mt-[140px]'>
        <a href='https://www.chilgok.go.kr/main.do' target='_blank'><img className='h-[30px] lg:h-[60px]' src={`${process.env.REACT_APP_STATIC_URL}/images/main/company/chilgok_logo.png`} alt='칠곡군' /></a>
        <a href='http://www.seniorgn.co.kr' target='_blank'><img className='h-[30px] lg:h-[60px]' src={`${process.env.REACT_APP_STATIC_URL}/images/main/company/seniorgn_logo.png`} alt='사단법인 대한노인회 강남구지회' /></a>
        <a href='http://hgdaycare.co.kr' target='_blank'><img className='h-[30px] lg:h-[60px]' src={`${process.env.REACT_APP_STATIC_URL}/images/main/company/hgdaycare_logo.png`} alt='할렐루야 광주 주간보호센터' /></a>
      </div>

      <Swiper
        loop={true}
        grabCursor={true}
        autoplay={{
          delay: 1,
          pauseOnMouseEnter: false,
          disableOnInteraction: false
        }}
        mousewheel={false}
        freeMode={true}
        spaceBetween={isMobile ? 10 : 30}
        speed={3000}
        slidesPerView={(isMobile ? 'auto' : window.innerWidth / 300)}
        modules={[FreeMode, Autoplay]}
        className="h-[284px] lg:h-[390px] mt-[80px] lg:mt-[140px] [&>*]:ease-linear"
      >
        {Array.from({ length: 7 }, (_, i) => (
          <SwiperSlide className='w-[202px] h-[284px] lg:w-auto lg:h-[390px] aspect-[202/284]'>
            <img
              className='rounded-[20px] h-[284px] lg:h-[390px]'
              alt={`뉴스${i + 1}`}
              src={`${process.env.REACT_APP_STATIC_URL}/images/main/news/Item${i + 1}.jpg`}
            />
          </SwiperSlide>
        ))}
        {Array.from({ length: 7 }, (_, i) => (
          <SwiperSlide className='w-[202px] h-[284px] lg:w-auto lg:h-[390px] aspect-[202/284]'>
            <img
              className='rounded-[20px] h-[284px] lg:h-[390px]'
              alt={`뉴스${i + 1}`}
              src={`${process.env.REACT_APP_STATIC_URL}/images/main/news/Item${i + 1}.jpg`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}